import styles from "../assets/styles/Herosection223.module.css"
import blob1 from "../assets/images/bannerlast.svg"
import blob2 from "../assets/images/blob5.svg"
import { Code, Monitor, Clipboard, Settings, Star, Phone } from "lucide-react";
import { motion } from "framer-motion";

export default function HeroSection223() {
  const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.15, // reduced for smoother phones
        duration: 0.5,
        ease: "easeOut",
      },
    }),
  };

  const letter = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  };

  const name = "MOHAMMED ELAOUJA".split("");

  const container = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.02 }, // reduced stagger
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.15, duration: 0.5, ease: "easeOut" },
    }),
  };

  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <div className={styles.topCircle}></div>
        <div className={styles.bottomCircle}></div>
      </div>

      <div className={styles.contentConteinar}>
        <div className={styles.content}>
          <div className={styles.contentLeft}>
            <motion.p
              variants={fadeUp}
              initial="hidden"
              animate="visible"
              custom={0}
            >
              Hi, there!
            </motion.p>

            <motion.h1
              className={styles.header}
              variants={container}
              initial="hidden"
              animate="visible"
              style={{ display: "inline", willChange: "transform, opacity" }}
            >
              {name.map((char, i) => (
                <motion.span
                  key={i}
                  variants={letter}
                  style={{ display: "inline-block", willChange: "transform, opacity" }}
                >
                  {char === " " ? "\u00A0" : char}
                </motion.span>
              ))}
              <motion.span
                variants={letter}
                style={{ display: "inline", marginLeft: "1rem", color: "black" }}
              >
                • Turning Ideas into Solutions
              </motion.span>
            </motion.h1>

            <motion.p
              className={styles.headerp}
              variants={fadeUp}
              initial="hidden"
              animate="visible"
              custom={1}
            >
              I am a Full Stack Programmer, ready to help you in making creative digital products.
            </motion.p>

            <a href="tel:+212654590690" className={styles.callout}>
              <Phone size={15} color="#fff" /> let's discuss
            </a>
          </div>

          <div className={styles.contentRight}>
            <div className={styles.blobWrapper}>
              <motion.img
                src={blob1}
                alt="Blob 1"
                className={styles.blob1}
                initial={{ opacity: 0, scale: 0.9, y: 15 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                style={{ willChange: "transform, opacity" }}
              />
            </div>
          </div>
        </div>

        <div className={styles.lowersection}>
          <p className={styles.serviceHeader}>MY SERVICE</p>
          <div className={styles.service}>
            {[
              {
                icon: <Code size={40} color="#db2254" style={{ marginBottom: "10px" }} />,
                title: "Programming",
                text: "Fast, modern web/mobile apps or backend systems using React, Swift, Python, and much more.",
              },
              {
                icon: <Monitor size={40} color="#db2254" style={{ marginBottom: "10px" }} />,
                title: "UI/UX",
                text: "Clean, intuitive interfaces that users enjoy.",
              },
              {
                icon: <Clipboard size={40} color="#db2254" style={{ marginBottom: "10px" }} />,
                title: "Guidance",
                text: "Practical guidance on web architecture, covering both frontend and backend.",
              },
              {
                icon: <Settings size={40} color="#db2254" style={{ marginBottom: "10px" }} />,
                title: "Maintaining",
                text: "Updates, fixes, and optimization for existing projects.",
              },
            ].map((service, i) => (
              <motion.div
                key={i}
                className={styles.serviveElement}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={i}
                style={{ willChange: "transform, opacity" }}
              >
                {service.icon}
                <p className={styles.serviceElementHeader}>{service.title}</p>
                <p className={styles.serviceElementp}>{service.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}


function HeroSection223OLd () {
  const labelVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2, // stagger
        duration: 0.6,
        ease: "easeOut",
      },
    }),
  };

  // Each letter animation
  const letter = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const name = "MOHAMMED ELAOUJA".split("");

    // Container for stagger
  const container = {
    hidden: { opacity: 1 }, // keep container visible
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.03, // delay between each letter
      },
    },
  };

  const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2, // stagger by index
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

  return (
   
    <div className={styles.main}>
        <div className={styles.background}>
            <div className={styles.topCircle}></div>
            <div className={styles.bottomCircle}></div>
        </div>
        <div className={styles.contentConteinar}>
            <div className={styles.content}>
                <div className={styles.contentLeft}>
                    {/* <p>Hi, there!</p> */}
                    <motion.p
              variants={fadeUp}
              initial="hidden"
              animate="visible"
              custom={0}
            >
              Hi, there!
            </motion.p>
<motion.h1
  className={styles.header}
  variants={container}
  initial="hidden"
  animate="visible"
  style={{ display: "inline" }}
>
  <span>
    {name.map((char, i) => (
      <motion.span
        key={i}
        variants={letter}
        style={{ display: "inline-block" }}
      >
        {char === " " ? "\u00A0" : char}
      </motion.span>
    ))}
  </span>
  
  {/* Animate the extra phrase as one unit */}
  <motion.span
    variants={letter}
    style={{ display: "inline", marginLeft: "1rem", color: "black" }}
  >
    • Turning Ideas into Solutions
  </motion.span>
</motion.h1>
            <motion.p
              className={styles.headerp}
              variants={fadeUp}
              initial="hidden"
              animate="visible"
              custom={1}
            >
              I am a Full Stack Programmer, ready to help you in making creative digital products.
            </motion.p>
                    <a href="tel:+212654590690" className={styles.callout}><Phone size={15}  color="#ffffffff"/>let's discuss</a>
                </div>
                <div className={styles.contentRight}>
                    <div className={styles.blobWrapper}>
                        <motion.img
  src={blob1}
  alt="Blob 1"
  className={styles.blob1}
  initial={{ opacity: 0, scale: 0.8, y: 20 }}
  animate={{ opacity: 1, scale: 1, y: 0 }}
  transition={{ duration: 0.6, ease: "easeOut" }}
/>
                    </div>
                </div>
            </div>
            <div className={styles.lowersection}>
                 <p className={styles.serviceHeader}>MY SERVICE</p>
                 <div className={styles.service}>
  {[
    {
      icon: <Code size={40} color="#db2254" style={{ marginBottom: '10px' }}/>,
      title: "Programming",
      text: "Fast, modern web/mobile apps or backend systems using React, Swift, Python, and much more."
    },
    {
      icon: <Monitor size={40} color="#db2254" style={{ marginBottom: '10px' }}/>,
      title: "UI/UX",
      text: "Clean, intuitive interfaces that users enjoy."
    },
    {
      icon: <Clipboard size={40} color="#db2254" style={{ marginBottom: '10px' }}/>,
      title: "Guidance",
      text: "Practical guidance on web architecture, covering both frontend and backend."
    },
    {
      icon: <Settings size={40} color="#db2254" style={{ marginBottom: '10px' }}/>,
      title: "Maintaining",
      text: "Updates, fixes, and optimization for existing projects."
    }
  ].map((service, i) => (
    <motion.div
      key={i}
      className={styles.serviveElement}
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      custom={i}
    >
      {service.icon}
      <p className={styles.serviceElementHeader}>{service.title}</p>
      <p className={styles.serviceElementp}>{service.text}</p>
    </motion.div>
  ))}

                 </div>
            </div>
        </div>
    </div>
 
  )
}